import { load } from 'cheerio';

import { extractPathnameFromUrlOrPath } from '@/utils/urlUtils';

export function extractIOProductPaths(htmlSource: string): string[] {
    const $ = load(htmlSource);
    const productPathsSet = new Set<string>();

    $('.io_item2_list').each((_, element) => {
        let href = $(element).closest('a').attr('href');
        if (!href) {
            href = $(element).find('.item_href').text().trim();
        }
        if (href) {
            const cleanPath = extractPathnameFromUrlOrPath(href);
            productPathsSet.add(cleanPath);
        }
    });

    return Array.from(productPathsSet);
}
